import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  CustomerContactPerson,
  CustomerDetailStatus,
} from "../../../types";
import { emptyCustomerDetails } from "../../../redux/initialState";
import { selectCustomerDetails } from "../../../redux/selector";
import { customersActions } from "../../../redux/slice";
import { useStyles } from "../CustomerDetailsForm/styles";

export const STATUS_OPTIONS = [
  CustomerDetailStatus.DRAFT,
  CustomerDetailStatus.ACTIVE,
  CustomerDetailStatus.INACTIVE,
];

const EMPTY_CONTACT: CustomerContactPerson = {
  contactId: Number(""),
  contactPersonName: "",
  role: "",
  contactPhone: "",
  contactEmail: "",
};

export const useCustomerDetailsForm = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const customerDetails = useSelector(selectCustomerDetails);
  const formData = customerDetails || emptyCustomerDetails;

  const statusValue = (
    formData.status || CustomerDetailStatus.DRAFT
  ).toLowerCase();

  const statusLabel = (status: string) =>
    t(`CUSTOMERS.DETAILS.STATUS_VALUES.${status.toUpperCase()}`);

  const getStatusBadgeClassName = (status: string) => {
    if (status === CustomerDetailStatus.ACTIVE) {
      return `${styles.statusBadge} ${styles.statusActive}`;
    }

    if (status === CustomerDetailStatus.INACTIVE) {
      return `${styles.statusBadge} ${styles.statusInactive}`;
    }

    return `${styles.statusBadge} ${styles.statusDraft}`;
  };

  const onStatusChange = (status: string) => {
    dispatch(customersActions.setCustomerDetailsStatus(status));
  };

  return {
    t,
    styles,
    formData,
    statusValue,
    statusLabel,
    getStatusBadgeClassName,
    onStatusChange,
    statusOptions: STATUS_OPTIONS,
    contactOne: (formData.contacts || [])[0] || EMPTY_CONTACT,
    contactTwo: (formData.contacts || [])[1] || EMPTY_CONTACT,
    contactThree: (formData.contacts || [])[2] || EMPTY_CONTACT,
  };
};
